import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-[#F4F3EE] flex items-center justify-center"
        data-testid="admin-loading"
      >
        <span className="gp-overline">// Verifying admin access…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
